import React from "react";

const defaultImage = `${process.env.PUBLIC_URL}/assests/img/Liberty_Logo.png`;

export default (props) => {
  return <img src={defaultImage} {...props} />;
};
